import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = [
    "container",
    "template",
    "rule",
    "ruleTypeSelect",
    "valueInput",
    "industrySelect",
    "indexNameSelect",
    "destroyInput"
  ]

  static values = {
    industryOptions: Array,
    indexNameOptions: Array
  }

  connect() {
    // Initialize existing rules on page load
    this.ruleTargets.forEach(rule => {
      this.initializeRule(rule)
    })
  }

  add(event) {
    event.preventDefault()

    // Clone the template
    const content = this.templateTarget.innerHTML
    const timestamp = new Date().getTime()
    const newContent = content.replace(/NEW_RECORD/g, timestamp)

    // Insert the new rule before the template
    this.containerTarget.insertAdjacentHTML('beforeend', newContent)

    // Initialize the newly added rule
    const newRules = this.containerTarget.querySelectorAll('[data-theme-rules-target="rule"]')
    const newRule = newRules[newRules.length - 1]
    this.initializeRule(newRule)
  }

  remove(event) {
    event.preventDefault()

    const rule = event.target.closest('[data-theme-rules-target="rule"]')
    const destroyInput = rule.querySelector('[data-theme-rules-target="destroyInput"]')

    if (destroyInput) {
      // For existing records, mark for destruction
      destroyInput.value = '1'
      rule.style.display = 'none'
    } else {
      // For new records, just remove from DOM
      rule.remove()
    }
  }

  ruleTypeChanged(event) {
    const rule = event.target.closest('[data-theme-rules-target="rule"]')
    const ruleType = event.target.value

    this.updateInputType(rule, ruleType)
  }

  initializeRule(rule) {
    const ruleTypeSelect = rule.querySelector('[data-theme-rules-target="ruleTypeSelect"]')
    if (ruleTypeSelect && ruleTypeSelect.value) {
      this.updateInputType(rule, ruleTypeSelect.value)
    }
  }

  updateInputType(rule, ruleType) {
    const valueInput = rule.querySelector('[data-theme-rules-target="valueInput"]')
    const industrySelect = rule.querySelector('[data-theme-rules-target="industrySelect"]')
    const indexNameSelect = rule.querySelector('[data-theme-rules-target="indexNameSelect"]')

    // Hide all inputs first
    valueInput.classList.add('hidden')
    industrySelect.classList.add('hidden')
    indexNameSelect.classList.add('hidden')

    // Clear any existing TomSelect instances
    if (industrySelect.tomselect) {
      industrySelect.tomselect.destroy()
    }
    if (indexNameSelect.tomselect) {
      indexNameSelect.tomselect.destroy()
    }

    // Show appropriate input based on rule type
    if (ruleType === 'industry') {
      industrySelect.classList.remove('hidden')
      this.initializeTomSelect(industrySelect, this.industryOptionsValue)
    } else if (ruleType === 'index_name') {
      indexNameSelect.classList.remove('hidden')
      this.initializeTomSelect(indexNameSelect, this.indexNameOptionsValue)
    } else {
      valueInput.classList.remove('hidden')

      // Update placeholder based on rule type
      if (ruleType === 'dt_establish_before') {
        valueInput.placeholder = '日付を入力 (例：2020-01-01)'
      } else if (['course_keyword', 'course_exclude_keyword', 'fund_name_keyword'].includes(ruleType)) {
        valueInput.placeholder = 'キーワードを入力（複数はカンマ区切り）'
      } else {
        valueInput.placeholder = '値を入力'
      }
    }
  }

  initializeTomSelect(selectElement, options) {
    // Parse existing values if any
    const existingValues = selectElement.getAttribute('data-initial-value') || ''
    const valueArray = existingValues ? existingValues.split(',').map(v => v.trim()) : []

    // Clear existing options
    selectElement.innerHTML = ''

    // Add options
    options.forEach(([label, value]) => {
      const option = document.createElement('option')
      option.value = value
      option.text = label
      if (valueArray.includes(String(value))) {
        option.selected = true
      }
      selectElement.appendChild(option)
    })

    // Initialize TomSelect
    const tomSelectInstance = new TomSelect(selectElement, {
      plugins: ['remove_button', 'input_autogrow'],
      create: false,
      persist: false,
      onChange: (values) => {
        // Update the hidden text input with comma-separated values
        const textInput = selectElement.closest('[data-theme-rules-target="rule"]')
                                      .querySelector('[data-theme-rules-target="valueInput"]')
        if (textInput) {
          textInput.value = values.join(',')
        }
      }
    })

    // Store reference to TomSelect instance
    selectElement.tomselect = tomSelectInstance

    // Set initial values
    if (valueArray.length > 0) {
      tomSelectInstance.setValue(valueArray)
    }
  }
}
